export default "__VITE_ASSET__2a2746c6__"